import { dateFormatOptions } from 'common/dateFormatterConfig';
import { IOptions } from 'common/reactSelectModels';
import { SaleOrder, SaleOrderProduct } from 'models/sale-order';
import moment from 'moment';
import React from 'react';
// import { Form } from 'react-bootstrap';
import { TransportForm } from './SaleOrderTransportForm';
import { Form, InputGroup } from 'react-bootstrap';

export interface SaleOrderConfirmProps {
  items: SaleOrderProduct[];
  carriers: IOptions[];
  loadingProviders: IOptions[];
  setForm: (form: TransportForm) => void;
  form: TransportForm;
  sendEmailNotification: boolean;
  setSendEmailNotification: (val: boolean) => void;
  isNew: boolean;
  order: SaleOrder | null;
  isOwnTransport: boolean;
  isRequesting: boolean;
}

export default function SaleOrderConfirm({
   items, carriers, loadingProviders, form, setForm, isNew, order, isOwnTransport, setSendEmailNotification, sendEmailNotification, isRequesting
   }: SaleOrderConfirmProps) {

  const getCarrierByCode = (code?: string): string => {
    return carriers.find(c => c.value + '' === code)?.label || '-';
  }

  const getTerminalByObjectId = (objectId?: string): string => {
    return loadingProviders.find(c => c.objectId === objectId)?.label || objectId || '-';
  }

  const rows: any[] = order ? order.rows.map(r => ({ productId: r.batchId, name: r.productName, fuelAmount: r.quantity, price: r.price })) : items.map(item => ({...item, name: item.exciseType }));

  const desiredDeliveryDate = form.date || (order?.desiredDeliveryDate && moment(order?.desiredDeliveryDate).toDate());

  return (
    <div className='d-flex flex-column'>
      <div className='row mb-2'>
        <div className='col'>KAUP</div>
        <div className='col'>KOGUS</div>
        { !isNew ? <div className='col'>HIND KM-ta</div> : null }
      </div>
        {
          rows.map(item => (
            <div className='row border-top pt-3 pb-2' key={item.productId + ''}>
              <div className='col'>
                <h5 className='font-weight-bold'>{item.name}</h5>
              </div>
              <div className='col'>
                <h5 className='font-weight-bold'>{item.fuelAmount} L</h5>
              </div>
             { !isNew ? <div className='col'>
                <h5 className='font-weight-bold'>{item.price ? item.price + '€/L' : '-'}</h5>
              </div> : null }
            </div>
          ))
        }
        <div className='d-flex flex-column border-top p-3 mx-n3'>
          <div className='d-flex justify-content-between'>
            <h5 className='font-weight-bold'>{ isOwnTransport ? 'Oma transport' : 'Terminal AS transport' }</h5>
          </div>
          <div className='d-flex flex-column'>
            {
              isOwnTransport &&
              <>
                <div className='d-flex'>
                  <span className='text-dark mr-2'>Terminal: </span><strong>{ isNew ? form.terminal?.label : getTerminalByObjectId(order?.objectId)}</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>Veovahend: </span><strong>{ isNew ? form.car?.label : order?.carName }</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>Autojuht: </span><strong>{ isNew ? form.driver?.label : order?.driverName }</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>Vedaja: </span><strong>{ isNew ? form.carrier?.label : order?.transporterName || getCarrierByCode(order?.transporterCode) }</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>{ isNew ? 'Soovitav tarneaeg:' : 'Tarneaeg:' } </span><strong>{ 
                    isNew ?
                      form.date ? new Intl.DateTimeFormat('et', dateFormatOptions).format(form.date) : null :
                      order?.deliveryDate? new Intl.DateTimeFormat('et', dateFormatOptions).format(order.deliveryDate) : null
                    }</strong>
                </div>                
              </>
            }
            {
              !isOwnTransport &&
              <>
                <div className='d-flex'>
                  <span className='text-dark mr-2'>Mahalaadimiskoht: </span><strong>{ isNew ? form.dropoffLocation?.label : order?.location?.address }</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>Soovitav tarneaeg: </span><strong>{ desiredDeliveryDate ? new Intl.DateTimeFormat('et', dateFormatOptions).format(desiredDeliveryDate) : null }</strong>
                </div>
                <div className='d-flex mt-1'>
                  <span className='text-dark mr-2'>Muu info:</span><strong style={{ whiteSpace: 'pre-line' }}>{ isNew ? form.description : order?.orderAdditionalInfo }</strong>
                </div>
              </>
            }
          </div>
        </div>
        { isNew && <div className='d-flex flex-column border-top p-3 mx-n3'>
          <Form.Check
            id={'check-email'}
            custom
            type="checkbox"
            label="Saada e-posti aadressile teavitus, kui broneering kinnitatakse"
            className='checkbox-large'
            onChange={() => setSendEmailNotification(!sendEmailNotification)}
            checked={sendEmailNotification}
          />
          {sendEmailNotification && <Form.Group controlId="notificationReceiverEmail" className="col-12 col-lg-6 mb-0 ml-3">
            <Form.Label className="mb-0 col-form-label-sm">E-posti aadress</Form.Label>              
            <InputGroup>
                <Form.Control
                    required
                    value={form.notificationReceiverEmail ?? undefined}
                    disabled={isRequesting}
                    type="email"
                    autoComplete="off"
                    className={form.validated && !form.notificationReceiverEmail ? 'is-invalid' : ''}
                    onChange={(e) => {setForm({...form, notificationReceiverEmail: e.target.value})}} />
            </InputGroup>
            {form.validated && !form.notificationReceiverEmail && <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>}
        </Form.Group>}
        </div>}
    </div>
  )
}